<template>
    <v-app class="login-shell">
        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>
<script>
    // Marco de las pantallas sin sesión (login): sin barra ni menú, sobre el
    // crema del shell para que la tarjeta se separe con una línea fina.
    export default {
        name: 'login-layout'
    }
</script>
<style scoped>
.login-shell.v-application {
    background: var(--app-canvas);
}
</style>
